import React from "react";

const DimensionalType = () => {
  return (
    <div className="fade-page-animation">
      <div className="centering">
        <h1 style={{ textAlign: "center", margin: 0 }}>Dimensional Type</h1>
      </div>

      <div className="centering" style={{ paddingTop: 0 }}>
        <p style={{ margin: 0, marginBottom: 16 }}>Curated Numbers:</p>
        <div className="project-flex-container">
          <div className="project-flex-item col-2">
            <img
              src="/dimensional_type/0-postwork.webp"
              alt='"0" with spiraled red ribbon effect'
            />
          </div>
          <div className="project-flex-item col-2">
            <img
              src="/dimensional_type/1-postwork.webp"
              alt='"1" with spiraled red ribbon effect'
            />
          </div>

          <div className="project-flex-item">
            <img
              src="/dimensional_type/2-postwork.webp"
              alt='"2" with spiraled red ribbon effect'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/3-postwork.webp"
              alt='"3" constructed with pieces of black tape effect'
            />
          </div>
          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/4-postwork.webp"
              alt='"4" constructed with pieces of black tape effect'
            />
          </div>

          <div className="project-flex-item">
            <img
              loading="lazy"
              src="/dimensional_type/5-postwork.webp"
              alt='"5" constructed with pieces of black tape effect'
            />
          </div>
        </div>

        <p>Curated Letters:</p>
        <div className="project-flex-container" style={{ paddingTop: 16 }}>
          <div className="project-flex-item">
            <img
              loading="lazy"
              src="/dimensional_type/letterlove-postwork.webp"
              alt='"Letter Love" monoline with metallic chrome effect'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/d-postwork.webp"
              alt='"D" monoline with metallic gold effect'
            />
          </div>
          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/e-postwork.webp"
              alt='"E" funk style with vibrant mixed lighting effects'
            />
          </div>

          <div className="project-flex-item">
            <img
              loading="lazy"
              src="/dimensional_type/g-postwork.webp"
              alt='"G" lowercase serif style with mixed lighting effects'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/m-postwork.webp"
              alt='"M" chocolate dessert with sprinkles'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/o-postwork.webp"
              alt='"O" glass with elegant lighting and reflections'
            />
          </div>

          <div className="project-flex-item">
            <img
              loading="lazy"
              src="/dimensional_type/p-postwork.webp"
              alt='"P" brown animal hair/fur effect'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/q-postwork.webp"
              alt='"Q" Art Deco style with embossed metal effect'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/s-postwork.webp"
              alt='"S" chrome car emblem effect'
            />
          </div>

          <div className="project-flex-item">
            <img
              loading="lazy"
              src="/dimensional_type/u-postwork.webp"
              alt='"U" blackletter style with cracked cement and overgrown moss'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/v-postwork.webp"
              alt='"V" melted cheese effect with marble countertop'
            />
          </div>
          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/w-postwork.webp"
              alt='"W" teal neon sign with metallic background'
            />
          </div>

          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/x-postwork.webp"
              alt='"X" melting block of ice with crystals inside'
            />
          </div>
          <div className="project-flex-item col-2">
            <img
              loading="lazy"
              src="/dimensional_type/y-postwork.webp"
              alt='"Y" inflated pink balloon floating in the sky'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DimensionalType;
